 
 class ProfileListRequest{
  constructor(){
    this.userId=null;
    this.ageFrom=0;
    this.ageTo=0;
    this.gender="";
    this.religion="";
    this.cast="";
    this.heightFrom=0;
    this.heightTo=0;
    this.createdFor="";
    this.maritalStatus="";
    this.motherTongue="";
    this.physicalStatus="";
    this.eatingHabits="";
    this.smokingHabits="";
    this.drinkingHabits="";
    this.familyStatus="";
    this.familyType="";
    this.familyValues="";
    this.occupation="";
    this.annualIncomeFrom=0;
    this.annualIncomeTo=0;
    this.employmentIn="";
    this.education="";
    this.line_1=null;
    this.line_2 =null;
    this.pageNum =null;
    this.pageSize =null;

  }}
  export default ProfileListRequest;